import linkAuth from 'src/apollo/mutations/linkAuth.gql'
import { checkMirror, clearQueryAfterAuth, consoleLogAPI, defaultLang } from 'src/common/functions'
import { userService } from 'src/common/user-service'
import { TokenService } from 'src/common/token-service'
import { useApolloClient } from '@vue/apollo-composable'
import { initCDA } from 'src/core/hooks/init-cda'
import { BASE_URL } from 'src/common/config'
import { getConfig } from 'src/configs'
import { useSystemStore } from 'src/stores/system'
import { useUserAuthStore } from 'src/stores/user/auth'
import { sentrySetUser } from 'src/common/sentry'

const config = getConfig()

export async function authBySlugs(to, router) {
  const isBot = useSystemStore().isBot
  const userAuthStore = useUserAuthStore()
  const userAuth = userAuthStore.getAuth

  const { resolveClient } = useApolloClient()
  return new Promise((resolve) => {
    if (isBot || userAuth || (to.name !== 'Auth' && to.name !== 'AuthEmail')) {
      return resolve(false)
    }

    const slug = to.params.slug
    const slug2 = to.params.slug2
    const hashStr = to.query.hashstr

    const custom_params = {}
    const freespin_slug = to.query.freespin
    if (freespin_slug) {
      custom_params.freespin = freespin_slug
    }
    if (to.name === 'AuthEmail') {
      let emailCode = to.query.code
      if (emailCode) {
        custom_params.email = emailCode
      }
    }

    const variables = {
      slug,
      slug2,
    }

    if (hashStr) {
      variables.hashStr = decodeURIComponent(hashStr)
    }

    const client = resolveClient()
    client
      .mutate({
        mutation: linkAuth,
        variables,
      })
      .then(async ({ data }) => {
        const { linkAuth } = data
        if ('token' in linkAuth) {
          userAuthStore.updateToken(linkAuth.token)
          userAuthStore.updateUser(linkAuth.user)
          userAuthStore.updateAuth(true)
          userAuthStore.updateUSSID(linkAuth.ussid)

          const lang = linkAuth.user?.language
          if (lang) {
            localStorage.setItem('u_lang', lang)
          }

          const tokenService = new TokenService()
          tokenService.setToken(linkAuth.token, linkAuth.ussid)

          sentrySetUser(linkAuth.user)

          if (!config.useMirrors) {
            return
          }

          const hasNewMirror = await checkMirror(client, to.query, lang)
          if (!hasNewMirror) {
            await initCDA(client)
          }
        } else {
          await userService.logout()
        }
      })
      .catch(consoleLogAPI)
      .finally(async () => {
        const query = clearQueryAfterAuth(to.query, [])

        const userLang = userAuthStore.getUserLanguage
        const currentLocale = to.params.locale || defaultLang
        const params = {}

        if (userLang !== currentLocale) {
          try {
            const resolvedRoute = router.resolve({ name: 'Home', query, params: { locale: userLang.toLowerCase() } })
            const newUrl = `${location.origin}${BASE_URL}${resolvedRoute.fullPath}`
            location.replace(newUrl)
            return
          } catch (e) {
            console.error(e)
          }
        }

        if (userLang && defaultLang !== userLang) {
          params.locale = userLang
        } else if (to.params.locale) {
          params.locale = to.params.locale
        }
        resolve({ name: 'Home', query, params })
      })
  })
}
